module.exports = __webpack_public_path__ + "static/media/change_replace.7e3943c4.svg";